import * as React from "react";
import { withStyles } from "@material-ui/core";
import imgImport from "modules/rateLibrary/assets/import.svg";
import imgImport_ok from "modules/rateLibrary/assets/import-ok.svg";
import { CostPlanStore } from "modules/costPlan/CostPlanStore";
import i18n from "i18n";

const styles = (theme) => ({
  container: {
    left: 0,
    top: 67,
    zIndex: 3,
    height: "calc(100vh - 67px)",
    display: "grid",
    gridTemplateRows: "auto 1fr",
    "& > :last-child": {
      backgroundColor: theme.palette.secondary.main,
    },
  },
  header: {
    backgroundColor: theme.palette.secondary.light,
    borderBottom: "1px solid #f2f2f2",
    height: "60px",
  },
  title: {
    lineHeight: "60px",
    fontSize: "16px",
    fontFamily: "Raleway",
    display: "inline-block",
    cursor: "pointer",
  },
  newProject: {
    left: "100%",
    top: 0,
    cursor: "auto",
  },
  closeLayerIcon: {
    right: 20,
    top: 80,
  },
  backLayerIcon: {
    left: 20,
    top: 20,
  },
  layerTitleContainer: {
    marginTop: 80,
  },
  layerSecondTitleContainer: {
    marginTop: 36,
  },
  layerSecondTitleMessage: {
    fontSize: "26px",
    fontFamily: "Raleway",
    fontWeight: 400,
    marginTop: 30,
  },
  layerTitle: {
    fontSize: "12px",
    fontFamily: "Raleway",
    fontWeight: 400,
  },
  input: {
    fontFamily: "Roboto",
    fontSize: "23px",
    fontWeight: 400,
    width: "520px",
    margin: "0 auto",
    marginTop: "30px",
    marginBottom: "70px",
    display: "block",
    "& :focus": {
      backgroundColor: "transparent",
    },
  },
  transitionEnter: {
    opacity: 0.01,
  },
  transitionEnterActive: {
    opacity: 1,
    transition: "opacity 300ms ease-in",
  },
  transitionLeave: {
    opacity: 1,
  },
  transitionLeaveActive: {
    opacity: 0.01,
    transition: "opacity 300ms ease-in",
  },
  chips: {
    display: "flex" as any,
    flexWrap: "wrap" as any,
    justifyContent: "center" as any,
  },
  chip: {
    margin: "1px 5px",
  },
  soon: {
    position: "relative" as any,
    top: "40%",
    color: "rgba(0, 0, 0, 0.34)",
    margin: "0px auto",
    width: 105,
    borderStyle: "solid",
    borderColor: "rgba(0, 0, 0, 0.34)",
    borderWidth: 1,
    borderRadius: 50,
    height: 21,
    paddingTop: 4,
    fontSize: 10,
  },
  createBlank: {
    position: "relative" as any,
    top: 163.5,
    color: "rgba(0, 0, 0, 0.34)",
    margin: "0px auto",
    width: 130,
    fontSize: "16px",
    fontFamily: "Raleway",
    fontWeight: 500,
  },
  cardImport: {
    // backgroundColor: "white",
    backgroundColor: "rgb(171, 194, 0)",
    transition: "box-shadow 300ms ease-in",
    // width: 230,
    width: 160,
    // height: 230,
    height: 145,
    margin: "30px 15px",
    paddingTop: "10px",
    float: "left" as any,
    "&:hover": {
      boxShadow:
        "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
    },
  },
  import: {
    width: "100%",
    // paddingTop: 25,
    padding: "6px 0 6px",
    // height: 70,
    textAlign: "center" as any,
    fontSize: "12px",
    fontFamily: "Roboto",
    fontWeight: 500,
    backgroundColor: "#fff",
  },
  boxCardImport: {
    display: "flex" as any,
    justifyContent: "center" as any,
    flexDirection: "column" as any,
  },
});

type IProps = {
  classes: any;
};

class ImportFile extends React.Component<IProps> {
  state = {
    name: "",
    disabled: false,
    location: Array(),
    share: Array(),
    index: 0,
    snack: false,
  };
  handleCloseLayerAdd = () => {};

  async fileChangedHandler(event) {
    let file = event.target.files[0];
    if (file == undefined) {
      CostPlanStore.fileUploadName = null;
      CostPlanStore.fileUpload = null;
    } else {
      CostPlanStore.fileUploadName = file.name;
      CostPlanStore.fileUpload = file;
    }
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.boxCardImport}>
        <p
          style={{
            margin: "0px 15px 0px",
            fontSize: "14px",
            textAlign: "center",
            fontWeight: "500" as any,
            textTransform: "uppercase",
          }}
        >
          {i18n.wbs.selectFile} <br />
          <span
            style={{
              fontSize: "11px",
              color: "#616161",
            }}
          >
            As informações serão lidas a partir da linha (2)
          </span>
        </p>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div className={classes.cardImport}>
            <input
              style={{ display: "none" }}
              accept=".xls, .xlsx"
              className={classes.input}
              id="contained-button-file"
              type="file"
              onChange={this.fileChangedHandler.bind(this)}
            />
            <label
              htmlFor="contained-button-file"
              style={{ cursor: "pointer" }}
            >
              <div
                style={{
                  width: "100%",
                  // height: 162,
                  backgroundColor: "rgba(171, 194, 0, 1)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "baseline",
                  paddingBottom: "10px",
                }}
              >
                {CostPlanStore.fileUploadName == null ||
                CostPlanStore.fileUploadName == "" ? (
                  <img
                    style={{ width: 80, height: 95, position: "relative" }}
                    src={imgImport}
                  />
                ) : (
                  <img
                    style={{ width: 80, height: 95, position: "relative" }}
                    src={imgImport_ok}
                  />
                )}
              </div>
              <div
                className={classes.import}
                style={{ wordBreak: "break-all" }}
              >
                {CostPlanStore.fileUploadName == null ||
                CostPlanStore.fileUploadName == ""
                  ? "Importar arquivo..."
                  : CostPlanStore.fileUploadName}
              </div>
            </label>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(ImportFile);



// WEBPACK FOOTER //
// ./src/modules/costPlan/components/pages/ImportFile.tsx